module.exports = __webpack_public_path__ + "static/media/024-thermometer-5.61d0be69.svg";